export default {
  setIndicatedProfessionals(state, indicatedProfessionals) {
    state.indicatedProfessionals = indicatedProfessionals;
  },
  setIndicatedProfessional(state, indicatedProfessional) {
    state.indicatedProfessional = indicatedProfessional;
  },
};
